export default __webpack_public_path__ + "fonts/ob_2.f96f4ad796f5726683e7bc85840ba30c.png";